import "./Header.scss";

import { images } from "../../utils/images";
import { paths } from "../../utils/paths";
import { AiOutlineSearch } from "react-icons/ai";
import Btn from "../../components/btn/Btn";
import { CgMenuRightAlt } from "react-icons/cg";
import { Fragment, useContext, useState, useEffect, useRef } from "react";
import SideBar from "../sideBar/SideBar";
import { NavLink, useNavigate } from "react-router-dom";
import { LiaAngleDownSolid } from "react-icons/lia";
import { multiLang } from "../../utils/enum";
import { mainContext } from "../../utils/WebContext";
import { MdCall } from "react-icons/md";

const Header = () => {
  const { headerService, involvedService } = useContext(mainContext);
  const [menu, setMenu] = useState(false);
  const [lang, setLang] = useState(multiLang[0]);
  const [dd, setDd] = useState(false);

  // Load Google Translate script when the component mounts
  useEffect(() => {
    const addGoogleTranslate = () => {
      const script = document.createElement("script");
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,kn", // English and Kannada
            layout:
              window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          "google_translate_element"
        );
      };
    };

    addGoogleTranslate();
  }, []);

  return (
    <Fragment>
      <header>
        <section className="header">
          <div className="content_wrap">
            <div className="nav_grid">
              <a href="/" className="logo">
                <img src={images.logoWhite} alt="Brand Logo" />
              </a>

              <nav>
                <NavLink to={paths.HOME}>Home</NavLink>
                <NavLink to={paths.ABOUT}>About</NavLink>
                <NavLink to={paths.SERVICES}>Services</NavLink>

                {headerService?.map((data) => {
                  return (
                    <Fragment key={data?._id}>
                      <NavLink to={`/info/${data?.slug}`}>{data?.name}</NavLink>
                    </Fragment>
                  );
                })}

                {involvedService?.length > 0 && (
                  <NavLink to={`/get-involved/${involvedService?.[0]?.slug}`}>
                    Get Involved
                  </NavLink>
                )}

                <NavLink to={paths.BLOGS}>News & Events</NavLink>
              </nav>

              <div className="right">
                <div id="google_translate_element"></div>

                {/* <div className="m">
                  <a href="tel:+91 8925816500">
                    <Btn
                      type="button"
                      title="+91 8925816500"
                      icon={<MdCall />}
                    />
                  </a>
                </div> */}

                <button
                  type="button"
                  className="icon_btn menu_btn"
                  onClick={() => setMenu(true)}
                >
                  <CgMenuRightAlt />
                </button>
              </div>
            </div>
          </div>
        </section>
      </header>
      <SideBar menu={menu} setMenu={setMenu} />
    </Fragment>
  );
};

export default Header;
